/**
 * Visszaadja az aktuális dátum másodpercét.
 * @returns {number} Az aktuális másodperc.
 */
module.exports.getCurrentSeconds = function getCurrentSeconds () {
  return (new Date()).getSeconds()
}
